<template>
    <div v-if="row.programKeywords && row.programKeywords.length > 0">
        <div v-for="(keyword, idx) in row.programKeywords" :key="'keyword' + idx" class="keyword-container">
            {{ keyword.keyword.name }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        "row": {
            type: Object
        },
        "col": {
            type: Object
        },
        "cell": {
            type: String | Number
        },
        "index": {
            type: String | Number
        }
    }
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Programme/ProgramKeywordChip.vue